import Block from './Block'
import Swiper from 'swiper';

export default class SliderHome extends Block {
  onEnterCompleted() {
    this.createSlider()
  }

  getElems() {
    this.sliderContainer = this.el.querySelector(".slider-home");
    this.sliderThumbnails = this.el.querySelectorAll(".slider-home-thumbs li");
  }

  createSlider() {
    this.slider = new Swiper(this.sliderContainer, {
      loop: true,
    });

    this.sliderThumbnails.forEach(thumb => {
      thumb.addEventListener("click", () => {
        this.sliderThumbnails.forEach(thumb => {
          thumb.classList.remove("active");
        });
        thumb.classList.add("active");
        const index = thumb.dataset.index;
        this.slider.slideTo(index);
      });
    });
  }
}
